<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  
    <!-- Data Peserta -->
    <CCardBody>
     <CRow>
       <DataPesertaPelatihanOnline/>
     </CRow>
     
      <CRow style="margin-top: -57px;">
        <CCol lg="12" class="table-responsive">
          <CDataTable 
            class="w-100" 
            :items="items" 
            :fields="fields" 
            hover 
            sorter
            :items-per-page="10"              
            :items-per-page-select='{ label : "Data Per Halaman"}' 
             pagination
          >
            <template #no="{index}">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
                </td>
            </template>
            <template #name="{item}">
              <td
                class="py-2"
                style="cursor: pointer"
              >{{ item.name ? item.name : '-' }}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">
                  {{item.email ? item.email : '-'}}
              </td>
            </template>
            <template #status_pembayaran="{item}">
              <td class="py-2">
                <span class="font-weight-bold text-success" v-if="item.status_pembayaran == 'success'">
                  Lunas
                </span>
                <span class="font-weight-bold text-danger" v-else-if="item.status_pembayaran == 'expire'">
                  Expired
                </span>
                <span class="font-weight-bold text-warning" v-else>
                  Belum Lunas
                </span>
              </td>
            </template>
            <template #completed_percent="{item}">
              <td class="py-2">
                  {{item.completed_percent ? item.completed_percent : '-'}}
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <CButton
                  color="success"
                  class="btn-sm"
                  square
                  @click="Detail(item, index)"
                >
                  <font-awesome-icon icon="eye" />
                </CButton>&nbsp;&nbsp;
              </td>
            </template>
          </CDataTable>
          <!-- <CPagination
            style="float:right"
            :pages="pagination.totalPages"
            responsive
            :active-page.sync="currentPageLms"
            @click="pageChange"
          /> -->
            <!-- :active-page.sync="currentPage" -->
        </CCol>
      </CRow>
      <!-- :active-page.sync="currentPageDataPesertaLms" -->
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">No Anggota</p>
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Email</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
            </div>
            <div class="col-7">
              <p>: AGT-1</p>
              <p>: Samantha Wiliam</p>
              <p>: samantha@gmail.com</p>
              <p>: 087837432432</p>
              <p>: 034329423423</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <router-link to="/keanggotaan/data-anggota">
            <CButton color="info">Detail</CButton>
          </router-link>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetailPeserta"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CRow class="px-3">
          <table class="table table-bordered font-weight-bold">
            <tr>
              <th class="bg-primary" style="width: 40%">No Lapor Pelatihan</th>
              <td>{{ items.no_lapor ? items.no_lapor : '-' }}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Nama Pelatihan</th>
              <td>{{items.nama_pelatihan ? items.nama_pelatihan : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
              <td>{{items.tanggal_daftar ? items.tanggal_daftar : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
              <td v-if="items.status_pembayaran">
                <span class="badge badge-success" v-if="items.status_pembayaran == 'success'">
                  Lunas
                </span>
                <span class="badge badge-danger" v-else-if="item.status_pembayaran == 'expire'">
                  Expired
                </span>
                <span class="badge badge-warning" v-else>
                  Belum Lunas
                </span>
              </td>
              <td v-else>
                -
              </td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Terstruktur</th>
              <td>{{items.skp_terstruktur ? items.skp_terstruktur : '0'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Non Terstruktur</th>
              <td>{{items.skp_tidak_terstruktur ? items.skp_tidak_terstruktur : '0'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Assesment</th>
              <td>{{items.skp_assessment ? items.skp_assessment : '0'}}</td>
            </tr>
            <!-- <tr>
              <th class="bg-primary" style="width: 40%">Status Pengisian Kuesioner</th>
              <td class="text-danger font-weight-bold">-</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status E-Certificate</th>
              <td class="text-success font-weight-bold">-</td>
            </tr> -->
          </table>
        </CRow>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetailPeserta = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Peserta -->
</template>

<script>

import DataPesertaService from "@/services/pelatihan/data-peserta.service";
import DataPesertaPelatihanLmsService from "@/services/pelatihan/data-peserta/data-peserta-lms.service";

import DataPesertaPelatihanOnline from "@/components/sertifikasi/datapeserta/DataPesertaPelatihanOnline";

import { AlertUtils } from "@/mixins/AlertUtils"; 
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "name",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Pendaftaran",
    sorter: true,
    filter: false
  },  
  {
    key: "completed_percent",
    label: "Persentase Pelatihan",
    sorter: true,
    filter: false
  },  
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false
  }, 
  {
    key: "aksi",
    _style: "width: 10% text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [
    AlertUtils, 
    // Pagination,
    KategoriAnggota
  ],
  components : {
    DataPesertaPelatihanOnline,
  },
  data() {
    return {
      currentPageLms: 0,
      pageSize: "10",
      formData: [
        {
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: ""
        }
      ],
      indexed : 0,
      pagination: {
        totalPages: 0
      },
      searchPelatihan : '',
      pelatihan:'',
      kategori_anggota : '',
      items: [],
      items_tampung: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: ""
      },
      dataPelatihan: [],
      fields,
      details: [],
      status: false,
      search: "",
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      modelIdWorkshopPelatihan: ""
    };
  },

  mounted() {
  
  },
  watch: {
    currentPageLms: function(val){
      // var page = val - 1;
      // this.indexed = page * this.pageSize;   
      // this.getData(val, this.pageSize, this.modelIdWorkshopPelatihan, this.searchPelatihan)
    }
  },
  methods: {
    changePageSize(e) {
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.modelIdWorkshopPelatihan, this.searchPelatihan);
    },
    cariData(val) {
        
        var cari = this.items_tampung.filter(function(element) {
          var name = element.name.toUpperCase().indexOf(val.toUpperCase()) 
          var email = element.email.toUpperCase().indexOf(val.toUpperCase())
          var tanggal_daftar = element.tanggal_daftar.toUpperCase().indexOf(val.toUpperCase())
          
         
          return  name >= 0|| 
                  email >= 0|| 
                  tanggal_daftar >= 0
        })

        if(val == "") {
          this.items = this.items_tampung
        } else {
          var percent = this.items_tampung.filter(element => element.completed_percent === val)
          if(percent != []) {
            this.items = percent
          } else {
            this.items = cari;
          }
        }
        
    },
    // pageChange() {
    //   this.getData(this.currentPageLms);
    // },

    Detail(item, index) {
      this.modalDetailPeserta = true;
      this.items = item
    },

    getData(currentPage, pageSize, id_pelatihan, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
       
      DataPesertaPelatihanLmsService.getDataPeserta(
        currentPage,
        pageSize,
        id_pelatihan,
        filter
      )
        .then(response => {
          loader.hide();

          vm.items = response.data;
          vm.items_tampung = response.data;
          // vm.pagination.totalPages = response.data.last_page;
          // vm.currentPage = response.data.last_page + 1;
          // vm.currentPageLms = response.data.current_page;
          // comment console console.log("ini total pages "+response.data.last_page);

        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDetailPeserta() {
      var vm = this;

      DataPesertaPelatihanLmsService.getDataPeserta()
      .then(response => {
          
          // comment console console.log(response.data.singleData);
          vm.detailPeserta = response.data.data
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getPelatihan() {
      var vm = this;
      DataPesertaService.getPelatihan()
      .then(response => {
        vm.dataPelatihan = response.data.data.content;
        // comment console console.log(response.data.data.content);
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    changePelatihan(value) {
      this.id_pelatihan = value.id_workshop_pelatihan;
      this.modelIdWorkshopPelatihan = value.id_workshop_pelatihan;

      this.getData(
        "0",
        this.pageSize,
        this.id_pelatihan
      );
    },
  }
};

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
